import type { UIViewBroadcastEvent } from "uicore-ts"


/** The payload a broadcast event was sent with; the caller names the payload type its event name carries. */
export function broadcastPayloadOf<Payload>(event: UIViewBroadcastEvent): Payload | undefined {
    if ("payload" in event) {
        return event.payload as Payload
    }
    return undefined
}
